import React from 'react';

const AppCard = ({ 
  children, 
  header,
  headerImg, 
  title, 
  subTitle,
  footer,
  className = '', 
  bodyClassName = '' 
}) => {
  return (
    <div className={`card bg-base-100 shadow-sm hover:shadow-md border border-base-200 rounded-2xl overflow-hidden ${className}`}>
      {header && <div className="card-header">{header}</div>}
      
      {headerImg && !header && (
        <figure className="w-full m-0 p-0">
          <img src={headerImg} alt="Card header" className="w-full object-cover m-0 p-0 block" />
        </figure>
      )}
      
      <div className={`card-body p-6 ${bodyClassName}`}>
        {title && (
          <h2 className={`card-title text-lg font-bold text-base-content ${subTitle ? 'mb-1' : 'mb-4 border-b border-base-200 pb-2'} w-full block`}>
            {title}
          </h2>
        )}
        
        {subTitle && (
          <div className="text-sm text-base-content/70 mb-4 border-b border-base-200 pb-2 w-full block">
            {subTitle}
          </div>
        )}
        
        {children}
        
        {footer && (
          <div className="card-actions mt-4 pt-4 border-t border-base-200 w-full">
            {footer}
          </div>
        )}
      </div>
    </div>
  );
};

export default AppCard;
